// extracted by mini-css-extract-plugin
export default {"expirationOptions":"ExpiredButton_expirationOptions__QmRzN"};